/**
 * TanStack Query hooks for `bot-traffic-detection`.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	botTrafficDetectionQueryKeys,
	type CreateBotTrafficBody,
	type ListBotTrafficResponse,
} from "./api";

export function useBotTrafficDetectionList(): UseQueryResult<ListBotTrafficResponse, Error> {
	return useQuery({
		queryKey: botTrafficDetectionQueryKeys.list(),
		queryFn: list,
	});
}

export function useBotTrafficDetectionCreate(): UseMutationResult<
	{ ok: boolean; event_id: string; created_at: number },
	Error,
	CreateBotTrafficBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: botTrafficDetectionQueryKeys.all });
		},
	});
}
